import React from 'react';
import { Breadcrumbs, Link, Typography, useTheme } from '@mui/material';
import NavigateNextIcon from '@mui/icons-material/NavigateNext';
import { Link as RouterLink } from 'react-router-dom';

export interface BreadcrumbItem {
  label: string;
  path?: string;
}

interface AppBreadcrumbsProps {
  items: BreadcrumbItem[];
}

const AppBreadcrumbs: React.FC<AppBreadcrumbsProps> = ({ items }) => {
  const theme = useTheme();

  if (items.length === 0) return null;

  return (
    <Breadcrumbs
      separator={<NavigateNextIcon fontSize="small" sx={{ color: theme.palette.text.secondary }} />}
      sx={{ mb: 1, '& .MuiBreadcrumbs-li': { minWidth: 0, maxWidth: '100%' } }}
    >
      {items.map((item, index) => {
        const isLast = index === items.length - 1;

        if (!item.path) {
          return (
            <Typography
              key={index}
              variant="body2"
              sx={{
                color: isLast ? theme.palette.primary.main : theme.palette.text.secondary,
                fontWeight: isLast ? 600 : 400,
                fontSize: '0.85rem',
                overflowWrap: 'anywhere',
              }}
            >
              {item.label}
            </Typography>
          );
        }

        return (
          <Link
            key={index}
            component={RouterLink}
            to={item.path}
            variant="body2"
            underline="hover"
            sx={{
              color: isLast ? theme.palette.primary.main : theme.palette.text.secondary,
              fontWeight: isLast ? 600 : 400,
              fontSize: '0.85rem',
              cursor: 'pointer',
              overflowWrap: 'anywhere',
              '&:hover': { color: theme.palette.primary.main },
            }}
          >
            {item.label}
          </Link>
        );
      })}
    </Breadcrumbs>
  );
};

export default AppBreadcrumbs;
